import { computed, defineComponent, onMounted, onUnmounted, ref, watch } from 'vue';
import { Popover } from 'bootstrap';
import { useRouter } from 'vue-router';
import { useDateFormat } from '@/composables/dateFormat';
import { useStore } from 'vuex';
import { EmergencyGetter } from '@/store/emergency/emergency.module';
import { Emergency } from '@/store/emergency/emergency.model';
import { FiscalYearGetter } from '@/store/fiscalYear/fiscalYear.module';
import { FiscalYear } from '@/store/fiscalYear/fiscalYear.model';
import LoadingComponent from '@/components/loading/Loading.vue';

export default defineComponent({
  name: 'EmergencyTableComponent',
  components: {
    LoadingComponent,
  },
  props: {
    emergencyTypeId: {
      type: Number,
      required: true,
    },
    fiscalYearId: {
      type: Number,
    },
    provinceId: {
      type: Number
    },
  },
  setup: (props) => {
    const router = useRouter();
    const dateFormat = useDateFormat();
    const store = useStore();
    const fiscalYear = computed<FiscalYear>(() => store.getters[FiscalYearGetter.BY_ID](props.fiscalYearId));
    const emergencies = computed<Emergency[]>(() => store.getters[EmergencyGetter.BY_TYPE](props.emergencyTypeId, props.provinceId, fiscalYear.value?.startDate, fiscalYear.value?.endDate));
    const isLoading = computed(() => store.getters[EmergencyGetter.STATUS] === 'init' || store.getters[EmergencyGetter.STATUS] === 'loading');
    const datatable = ref<HTMLTableElement>();
    const dtInstance = ref();
    const popoverList = ref<Popover[]>([]);

    onMounted(() => {
      Promise.resolve(initialPopover())
        .then(() => initialDataTable());
    });

    watch(() => (props.provinceId), () => {
      Promise.resolve(initialPopover())
        .then(() => initialDataTable());
    });

    onUnmounted(() => {
      dtInstance.value?.destroy();
    });

    const selectedClick = (id: number) => {
      const emergencyType = (props.emergencyTypeId !== 1)
        ? (props.emergencyTypeId !== 2)
          ? 'protest'
          : 'problem'
        : 'disaster';
      router.push(`/emergencies/${emergencyType}/${id}`);
    };

    const initialDataTable = () => {
      Promise.resolve(dtInstance.value?.destroy())
        .then(() => {
          const dt = datatable.value as HTMLTableElement;
          if (!$.fn.dataTable.isDataTable(dt)) {
            dtInstance.value = $(dt).DataTable({
              language: {
                emptyTable: 'ไม่พบข้อมูล',
                info: 'แสดง _START_ ถึง _END_ จากจำนวนทั้งหมด _TOTAL_',
                infoEmpty: 'แสดง 0 ถึง 0 จากจำนวนทั้งหมด 0',
                infoFiltered: '(ค้นหาจากจำนวนทั้งหมด _MAX_)',
                lengthMenu: 'แสดงข้อมูล _MENU_',
                paginate: {
                  next: 'ถัดไป',
                  previous: 'ก่อนหน้า',
                  first: 'First',
                  last: 'Last'
                },
                search: 'ค้นหา:',
                zeroRecords: 'ไม่พบข้อมูลที่ค้นหา',
              }
            });
          }
        });
    };

    const initialPopover = () => {
      const popoverTriggerList = computed<HTMLElement[]>(() => [].slice.call(document.querySelectorAll('[data-bs-toggle="popover-task"]')) as HTMLElement[]);
      popoverList.value.map(element => element.hide());
      popoverList.value = popoverTriggerList.value?.map(element => new Popover(element, { trigger: 'hover', placement: 'right' }));
    };

    const thaiDate = (date: Date) =>
      dateFormat.toThaiDate(date, 'short');

    return {
      emergencies,
      datatable,
      isLoading,
      selectedClick,
      thaiDate,
    };
  },
});
